// React
import React, { useEffect, useState } from 'react';
// componentes
import { useStyles } from "./style";
// Redux

import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import SolicitudesEmpadronamiento from 'pages/solicitudesExtranjero/solicitudesNuevas/SolicitudesEmpadronamiento'
import SolicitudesExtranjero from 'pages/solicitudesExtranjero/solicitudesNuevas/SolicitudesEmpadronamiento/datosCiudadanosExtranjero'
import { useHistory } from "react-router-dom";
import allActions from 'store/actions';
import { useDispatch } from 'react-redux'
import DescargarConstanciaEmpadronamiento from '../DescargarConstanciaEmpadronamiento'

function ComponenteDelegacion (props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [openmodalProcesarSolicitudExtranjero, setOpenModalProcesarSolicitudExtranjero] = useState(false);
    const [datos, setDatos] = useState({idSolicitudObtenido: '', datosSolicitudExtranjero: {}, accionDeProceso: '', isNacional: ''});
    let history = useHistory();

    const openModalForNewCensusRegistration = () =>{ 
        props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_GENERADO({cui: '', usuario: ''})
        props.SOLICITUD_EMPADRONAMIENTO_SET_IS_INSCRIPCION_ACTUALIZACION('Nuevo Empadronamiento o Actualización de datos')
        setOpen(true)
    }    

    const closeModalForNewCensusRegistration = (isCancel)=> { 
        props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO('')
        props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO('')
        props.SET_DATA_IS_REGISTERED({})
        props.CLEAR_DATA_DATOS_IDENTIDAD();  
        props.CLEAR_DATA_DATOS_IDENTIDAD_DEL_CIUDADANO();
        props.SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP(0);
        
        setOpen(false);
        // Limpiando la cita en proceso para que al abrir nuevamente el modal,
        // ya no se abra con la información del ciudadano cuya cita estabamos atendiendo.
        if (props.citaEnProceso.idCita !== "" && props.citaEnProceso.cleanRegisterOnExit === true) {
                props.CITA_EMPADRONAMIENTO_SET_CITA_EN_PROCESO(
                props.citaEnProcesoVacia
          );
        }
        if(isCancel)
            return history.push("/",{})
            
        history.push("/generarSolicitudDeDelegacion",{})
    }    

    //abrimos el modal para procesar la solicitud de extranjero Y NACIONAL DE DELEGACIONES
    const AbrirModalProcesarSolicitudExtranjero = () => { 
        let data = props.datosSolicitudDelegacion?.data
        if(data?.idSolicitud){
            setDatos({                
                idSolicitudObtenido: data.idSolicitud,
                datosSolicitudExtranjero: data,
                accionDeProceso: data.datosSolicitudEmpadronamiento.tipoOrigen +' / NUEVA '+data.datosSolicitudEmpadronamiento.tipoSolicitud,
                isNacional: data.datosSolicitudEmpadronamiento.nacionalExtranjero,
            })
            props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO('')
            props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO('')
            props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_CIUDADANO_TABLE(data)
            props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD([])                
            props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_RENAP(data.datosSolicitudEmpadronamiento.idSolicitud)
            props.SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI(data.datosDpiSolicitudEmpadronamiento?.cui) 
            setOpenModalProcesarSolicitudExtranjero(props.datosSolicitudDelegacion?.open)
        }
    }
    const CerrarModalProcesarSolicitudExtranjero = ()=>{         
        props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO('')
        props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO('')
        setDatos({idSolicitudObtenido: '', datosSolicitudExtranjero: {}, accionDeProceso: '', isNacional: ''})
        setOpenModalProcesarSolicitudExtranjero(false)        
    }    

    useEffect(()=>{
        if(props.datosSolicitudDelegacion === '')
            openModalForNewCensusRegistration()
        else if(props.datosSolicitudDelegacion?.open)
            AbrirModalProcesarSolicitudExtranjero()
    },[props.datosSolicitudDelegacion])

    return (
        <div className={classes.root}>            
            {
                (props.idSoliciutudDelegacionProcesado?.open) && (                        
                    <DescargarConstanciaEmpadronamiento />
                )
            }           
            {open && (
                <SolicitudesEmpadronamiento
                    // datosSolicitudExtranjero={this.state.datosSolicitudExtranjero}
                    // actualizarTabla={this.showList}
                    open={open}   
                    handleClose={closeModalForNewCensusRegistration}
                    citaEnProceso={props.citaEnProceso}
                    AbrirModalProcesarSolicitudExtranjero={AbrirModalProcesarSolicitudExtranjero}
                    ejecutar={false}
                    // accionDeProceso={this.state.accionDeProceso}
                    // isNacional={this.state.isNacional}
                    // ObtenerTotalDeSolicitudesPendientesDeRealizar={this.props.ObtenerTotalDeSolicitudesPendientesDeRealizar}
                />
            )}

            {
                (openmodalProcesarSolicitudExtranjero) && (
                    <SolicitudesExtranjero
                        idSolicitudObtenido={datos.idSolicitudObtenido}
                        datosSolicitudExtranjero={datos.datosSolicitudExtranjero}
                        open={openmodalProcesarSolicitudExtranjero}   
                        handleClose={CerrarModalProcesarSolicitudExtranjero}
                        accionDeProceso={datos.accionDeProceso}
                        isNacional={datos.isNacional}
                    />
                )
            }         
        </div>
    )
}
export default connect(mapStateToProps, mapDispatchToProps)(ComponenteDelegacion);